import { gql } from "@apollo/client";
import { AccountDeliveryDriverType } from "../../types/AccountDeliveryDriverType";
import { AccountDeliveryDriverInput } from "../../types/AccountDeliveryDriverInput";
import { client } from "graphql/client";

export const CREATE_ACCOUNT_DELIVERY_DRIVER_FOR_PORTAL = gql`
    mutation CreateAccountDeliveryDriverForPortal($input: AccountDeliveryDriverInput!) {
        createAccountDeliveryDriverForPortal(input: $input) {
            id
        }
    }
`;

export interface CreateAccountDeliveryDriverForPortalResponse {
    createAccountDeliveryDriverForPortal: AccountDeliveryDriverType;
}

export interface CreateAccountDeliveryDriverForPortalVariables {
    input: AccountDeliveryDriverInput;
}

export const createAccountDeliveryDriverForPortal = async (input: AccountDeliveryDriverInput): Promise<boolean> => {
    const { data } = await client.mutate({
        mutation: CREATE_ACCOUNT_DELIVERY_DRIVER_FOR_PORTAL,
        variables: { input }
    });
    return data.createAccountDeliveryDriverForPortal;
};
